export default __webpack_public_path__ + "legacy/static/media/AndroidInstructions.e7a7013e.png";